import { createContext } from 'react'

import type { AuthContextValue as PortalAuthContextValue } from './types'

export const AuthContext = createContext<PortalAuthContextValue | null>(null)
